<template>
  <v-container
    fluid
    class="px-1 py-2"
  >
    <div class="mb-2">
      <v-row no-gutters>
        <v-col>
          <span class="title">Flights</span>
        </v-col>
        <v-col
          cols="12"
          sm="8"
          md="6"
        >
          <v-row no-gutters>
            <v-col class="flex-grow-1">
              <flight-date-picker
                v-model="dayOfOrigin"
                :now="now"
              />
            </v-col>
            <v-col class="flex-grow-0 ml-2">
              <airport-select
                v-model="selectedAirport"
                :items="availableAirports"
              />
            </v-col>
            <v-col class="flex-shrink-1 flex-grow-0 ml-1">
              <v-btn
                v-if="dayOfOrigin"
                @click="applyFilter"
                depressed
                height="40"
                :disabled="loading"
                :loading="loading"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
    <progress-bar :isLoading="loading" />
    <template v-for="item in visibleItems">
      <flight-item
        :value="item"
        :key="item.id"
        @toggle="toggle"
        @moreInfo="openInfo(item, $event)"
        :now="now"
        :expandedId="expandedId"
      >
      </flight-item>
      <v-divider :key="'d' + item.id" />
    </template>

    <v-dialog
      v-if="dialogFlight"
      v-model="dialog"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar
          dark
          color="primary"
          dense
        >
          <v-btn
            icon
            dark
            @click="closeInfo"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            {{ dialogFlight.data.number }}{{ dialogFlight.data.suffix }}
            <span class="success--text">{{ dialogFlight.data.actualDepApIata }}</span> -
            <span class="success--text">{{ dialogFlight.data.actualArrApIata }}</span>
          </v-toolbar-title>
          <v-spacer />
          <v-toolbar-items />
        </v-toolbar>
        <flight-info
          v-if="dialogFlight.type === 'general'"
          :value="dialogFlight.data"
        />
        <ldm-info
          v-if="dialogFlight.type === 'ldm'"
          :flightId="dialogFlight.data.id"
        />
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex'
  import FlightItem from '@/components/FlightItem'
  import FlightInfo from '@/components/FlightInfo'
  import LdmInfo from '@/components/LdmInfo'
  import FlightDatePicker from '@/components/FlightDatePicker'
  import AirportSelect from '@/components/AirportSelect'
  import ProgressBar from '@/components/ProgressBar'

  export default {
    name: 'FlightsSearch',
    components: {
      FlightInfo,
      LdmInfo,
      FlightItem,
      FlightDatePicker,
      AirportSelect,
      ProgressBar
    },
    data: () => ({
      loading: false,
      expandedId: null,
      dialogFlight: null,
      dialog: false
    }),
    computed: {
      ...mapState({
        items: (state) => state.flightsSearch.items,
        airport: (state) => state.flightsSearch.airport,
        itemsFilter: (state) => state.flightsSearch.filter,
        now: (state) => state.app.now
      }),
      ...mapGetters({
        availableAirports: 'flightsSearch/availableAirports'
      }),
      dayOfOrigin: {
        get() {
          return this.itemsFilter.dayOfOrigin
        },
        set(value) {
          this.updateFilter({ ...this.itemsFilter, dayOfOrigin: value })
          this.applyFilter()
        }
      },
      selectedAirport: {
        get() {
          return this.airport
        },
        set(value) {
          this.setAirport(value)
        }
      },
      visibleItems() {
        if (!this.selectedAirport) return this.items
        return this.items.filter(
          (f) =>
            f.actualDepApIata === this.selectedAirport ||
            f.actualArrApIata === this.selectedAirport
        )
      }
    },
    created() {
      this.applyFilter()
    },
    methods: {
      ...mapActions({
        search: 'flightsSearch/search',
        updateFilter: 'flightsSearch/updateFilter',
        setAirport: 'flightsSearch/setAirport'
      }),
      toggle(id) {
        this.expandedId === id ? (this.expandedId = null) : (this.expandedId = id)
      },
      openInfo(flight, type) {
        this.dialogFlight = { data: flight, type: type }
        this.dialog = true
      },
      closeInfo() {
        this.dialogFlight = null
        this.dialog = false
      },
      applyFilter() {
        this.loading = true
        this.search().finally(() => (this.loading = false))
      }
    }
  }
</script>
